export class RequestUser {
  constructor(
    public userid: String,
    public latitude: Number,
    public longitude: Number
  ) { }
}

export class RealUser {
  constructor(
    public latitude: number,
    public longitude: number,
    public items: any[]
  ) { }
}

export class SearchRequest {
  constructor(
    public userid: String,
    public latitude: Number,
    public longitude: Number,
    public searchstring: String,
    public searchcharacteristics: Array<SearchCharacteristic>,
    public rowCount: Number,
    public pageNumber: Number,
    public sortField: String,
    public direction: String,
    public venueId: Number
  ) { }
}

export class BrewerySearchRequest {
  constructor(
    public userid: String,
    public latitude: Number,
    public longitude: Number,
    public searchstring: String,
    public country: String,
    public rowCount: Number,
    public pageNumber: Number
  ) { }
}

export class SearchVenueRequest {
  constructor(
    public usesrid: String,
    public latitude: Number,
    public longitude: Number,
    public rowCount: Number,
    public pageNumber: Number,
    public distance: Number
  ) { }
}

export class AddBeerRequest {
  constructor(
    public creationUserId: String,
    public latitude: Number,
    public longitude: Number,
    public name: String,
    public abv: number,
    public ebc: number,
    public ibu: number,
    public brewery_id: number,
  ) { }
}

export class AddBreweryRequest {
  constructor(
    public name: String,
    public country: String,
    public city: String,
    public creationUserId: String,
    public latitude: Number,
    public longitude: Number,
  ) { }
}

export class SearchCharacteristic {
  constructor(
    public key: String,
    public value: Number
  ) { }
}

export enum SearchType {
  SEARCH_COLOUR,
  SEARCH_AROMA,
  SEARCH_HIVE
}

export class SearchCharacteristicWithType {
  constructor(
    public type: Number,
    public characteristic: SearchCharacteristic
  ) { }
}

export class BeerProfileRequest {
  constructor(
    public userid: String,
    public latitude: Number,
    public longitude: Number,
    public beerid: String,
    public venueid: Number
  ) { }
}

export class SimilarBeerRequest {
  constructor(
    public userid: String,
    public latitude: Number,
    public longitude: Number,
    public beerid: String,
    public venueid: Number
  ) { }
}

export class WishlistAdd {
  constructor(
    public userid: String,
    public latitude: Number,
    public longitude: Number,
    public beerid: String
  ) { }
}

export class WishlistRemove {
  constructor(
    public userid: String,
    public latitude: Number,
    public longitude: Number,
    public id: String
  ) { }
}

export class WishlistGet {
  constructor(
    public userid: String,
    public latitude: Number,
    public longitude: Number,
    public rowCount: Number,
    public pageNumber: Number,
    public sortField: String,
    public direction: String,
    public venueId: Number
  ) { }
}

export class Newsfeed {
  constructor(
    public image: String,
    public updateUserId: Number,
    public type: String,
    public title: String,
    public url: String,
    public creationUserId: String,
    public id: Number,
    public text: String,
    public updateTs: String,
    public creationTs: String
  ) { }
}

//AnalysisItem = { itemKey: String, itemValue: Number};
export class AnalysisItem {
  constructor(
    public analysisKey: String,
    public analysisValue: Number
  ) { }
}

export class AnalysisRemove {
  constructor(
    public id: String
  ) { }
}

export class LocalCharacteristic {
  constructor(
    public name: String,
    public value: Number
  ) { }
}

export class StringAnalysisItem {
  constructor(
    public analysisKey: String,
    public analysisValue: String
  ) { }
}

export class BeerStat {
  constructor(
    public groupid: number,
    public groupname: string,
    public nbrofanalyses: number
  ) { }
}

export class Analysis {
  constructor(
    public userid: String,
    public user_id: String,
    public latitude: Number,
    public longitude: Number,
    public beer_id: String,
    public characteristics: Array<any>,
    public notes: string,
    public totalexperience: Number,
    public sweet: Number,
    public sour: Number,
    public bitter: Number,
    public malty: Number,
    public fruity: Number,
    public hoppy: Number,
    public colour: Number, //added by Steven
    public id?: String,
    public characteristicsvalues?: Array<any>,
    public intensity?: Number,
    public alcohol?: Number,
    public body?: Number,
    public astringent?: Number,
    public carbonation?:Number
  ) { 
    console.log("hello Analysis")
  }
}

export class AddAnalysis {
  constructor(
    public user_id: String,
    public latitude: Number,
    public longitude: Number,
    public beer_id: String,
    public characteristics: Array<any>,
    public id?: String,
    public note?: String
  ) { }
}

export class UpdateAnalysis {
  constructor(
    public user_id: String,
    public latitude: Number,
    public longitude: Number,
    public beer_id: String,
    public characteristics: Array<any>,
    public id: String,
    public note?: String
  ) { }
}

export class BeerAnalysis {
  constructor(
    public id: Number,
    public colour: Number,
    public sweet: Number,
    public sour: Number,
    public bitter: Number,
    public hoppy: Number,
    public fruity: Number,
    public malty: Number,
    public intensity: Number,
    public body: Number,
    public astringency: Number,
    public totalexperience: Number,
    public trouble: Number,
    public beerInfo: BeerInfo,
    public characteristics: Array<any>
  ) { }
}


export class BeerInfo {
  constructor(
    public id: String,
    public name: String,
    public beerId: String,  // OBSOLETE, to de deleted
    public abv: Number,
    public ibu: Number,
    public ebc: Number,
    public verified: Number,
    public breweryInfo: BreweryInfo,
    public logo: String,
  ) { }
}

export class BreweryInfo {
  constructor(
    public id: String,
    public name: String,
    public breweryId: String,
    public houseNumber: String,
    public postalCode: String,
    public facebook: String,
    public city: String,
    public provinceState: String,
    public country: String,
    public website: String,
    public remark: String,
    public email: String,
    public tel: String,
    public verified: Number,
    public brexweryVerified: Number
  ) { }
}

export class Brewery {
  public id: Number;
  public country: String;
  public name: String;
  public city: String;
}

export class Country {
  public code: String;
  public name: String;
}

export class Venue {
  public type: String;
  public title: String;
  public id: Number;
  public city: String;
  public distance: Number;
  public latitude: Number;
  public longitude: Number;
  public selected: Boolean;
}

export interface BaseFlavors {
  sweet: number;
  sour: number;
  bitter: number;
  fruity: number;
  hoppy: number;
  malty: number;
  color: number;
  clarity: number;
}